import React from 'react';
import { motion } from 'framer-motion';
import { Phone, ArrowRight } from 'lucide-react';

export default function CTASection() {
  const scrollToKontakt = () => {
    const el = document.querySelector('#kontakt');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section data-testid="cta-section" className="py-24 sm:py-32 bg-[#1A3A22] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#2D5A27]/30 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-[#10B981]/15 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="text-[#10B981] font-['Manrope'] text-sm font-semibold tracking-[0.2em] uppercase">
            Bereit loszulegen?
          </span>
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tighter mt-4 mb-6">
            Bereit für <span className="text-[#10B981]">Ihr Projekt?</span>
          </h2>
          <p className="font-['Manrope'] text-white/60 text-base sm:text-lg max-w-lg mx-auto mb-10">
            Lassen Sie uns gemeinsam Ihr Elektroprojekt in Bonn umsetzen. Kontaktieren Sie uns für eine
            kostenlose und unverbindliche Beratung – Ihr Elektriker-Meisterbetrieb seit 1966.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToKontakt}
              data-testid="cta-inquiry-button"
              className="inline-flex items-center justify-center gap-2 bg-[#10B981] hover:bg-[#2D5A27] text-white px-10 py-4 font-['Outfit'] font-semibold text-base tracking-[0.1em] uppercase transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
            >
              Anfrage stellen
              <ArrowRight className="w-5 h-5" />
            </button>
            <a
              href="tel:+492282346 44"
              data-testid="cta-phone-button"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/30 hover:border-white text-white px-10 py-4 font-['Outfit'] font-semibold text-base tracking-[0.1em] uppercase transition-all duration-300 hover:-translate-y-1"
            >
              <Phone className="w-5 h-5" />
              Anrufen
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
